export default __webpack_public_path__ + "static/media/ag.88911a63.svg";